var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearhIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1432_2552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29936 14.6456C5.35442 14.6456 3.51494 13.884 2.14411 12.5015C0.76157 11.1189 0 9.29116 0 7.34623C0 5.38958 0.76157 3.56181 2.14411 2.17927C3.51494 0.796729 5.35442 0.046875 7.29936 0.046875C9.24429 0.046875 11.0838 0.796729 12.4663 2.17927C13.8371 3.56181 14.5987 5.38958 14.5987 7.34623C14.5987 9.29116 13.8371 11.1189 12.4663 12.5015C11.0838 13.884 9.24429 14.6456 7.29936 14.6456ZM7.29936 13.0053C5.78793 13.0053 4.35852 12.4195 3.29233 11.3533C2.22613 10.2753 1.62859 8.85765 1.62859 7.34623C1.62859 5.82309 2.22613 4.4054 3.29233 3.32748C4.35852 2.26129 5.78793 1.67546 7.29936 1.67546C8.81078 1.67546 10.2402 2.26129 11.3064 3.32748C13.5208 5.5419 13.5208 9.13885 11.3064 11.3533C10.2402 12.4195 8.81078 13.0053 7.29936 13.0053Z",
    fill: "#4F565E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0363 15.3373C13.9426 15.3373 13.8489 15.3021 13.7786 15.2318L12.2086 13.6618C12.478 13.4509 12.7241 13.24 12.9584 12.994C13.2279 12.7362 13.4622 12.455 13.6848 12.1621L15.2666 13.7438C15.4072 13.8844 15.4072 14.107 15.2666 14.2476C15.1963 14.3062 15.1142 14.3414 15.0205 14.3414C14.9385 14.3414 14.8682 14.3179 14.8096 14.2711L14.3527 14.8335C14.4113 14.9623 14.3878 15.1147 14.2824 15.2318C14.2121 15.3021 14.1183 15.3373 14.0363 15.3373Z",
    fill: "#4F565E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4768 19.9529C18.0785 19.9529 17.6918 19.8006 17.4106 19.5076L14.1066 16.2153C13.8254 15.9341 13.6731 15.5475 13.6731 15.1491C13.6731 14.739 13.8254 14.3524 14.1066 14.0712C14.3995 13.79 14.7744 13.626 15.1845 13.626C15.5946 13.626 15.9695 13.79 16.2624 14.0712L19.5548 17.3635C20.1406 17.9611 20.1406 18.9218 19.5548 19.5076C19.2618 19.8006 18.8869 19.9529 18.4768 19.9529Z",
    fill: "#4F565E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93265 9.71282C3.62041 8.40058 3.62041 6.2799 4.93265 4.96766C5.06153 4.82706 5.06153 4.60445 4.93265 4.47557C4.79206 4.33497 4.56944 4.33497 4.42885 4.47557C2.84712 6.05729 2.84712 8.62319 4.42885 10.2049C4.49914 10.2752 4.59288 10.3104 4.67489 10.3104C4.76862 10.3104 4.86235 10.2752 4.93265 10.2049C5.06153 10.076 5.06153 9.85342 4.93265 9.71282Z",
    fill: "#4F565E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1432_2552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearhIcon);
export default __webpack_public_path__ + "static/media/searh_icon.ca6ab6946481af0264ffa0bedf27e915.svg";
export { ForwardRef as ReactComponent };